import { useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import AddVideoModal from 'hb-react/shared/components/DesignSystem/QuillEditor/AddVideoModal';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import { MIME_TYPE_VIDEOS } from 'hb-react/shared/constants/mimeTypeVideos';

import ToolbarItem from '../components/ToolbarItem';

// @see config/hivebrite_storage.yml
export const ACCEPT_VIDEOS = MIME_TYPE_VIDEOS;

const Video = () => {
  const {
    displayVideoModal,
    setDisplayVideoModal,
    options,
    setForceEditorFocus,
  } = useQuillEditorContext();

  const { tooltips: tooltipsOptions } = options ?? {};

  const openAddVideoModal = useCallback(() => {
    setDisplayVideoModal?.(true);
  }, [setDisplayVideoModal]);

  return (
    <>
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={openAddVideoModal}
        icon={<FontAwesomeIcon iconName="circle-play" height="16px" />}
        dataTestId="inline-video-action"
        ariaLabel={s__('QuillEditorAccessibility|Insert video link')}
        tooltip={tooltipsOptions?.inlineVideo}
        enableFontAwesomeIcon
      />
      {displayVideoModal && (
        <AddVideoModal
          isOpen={displayVideoModal}
          onClose={() => setDisplayVideoModal?.(false)}
        />
      )}
    </>
  );
};

export default Video;
